module.exports = __webpack_public_path__ + "static/media/Health.ddaef8e1.svg";